import React, { useEffect } from "react";
import {
  AssignmentDispatchContext,
  AssignmentStateContext,
  useAssignmentStoreDefaults,
} from "pages/AppPages/PatientPages/AssignmentsForPatients/assignmentStore";
import { useGetAssignments, useGetSubmissions } from "utils/hooks";
import { User, Group, Assignment, AssignmentSubmission } from "types";

interface Props {
  patient?: User | null;
  group?: Group;
  children: any;
}

const AssignmentContextTherapistWrapper = ({
  children,
  patient,
  group,
}: Props) => {
  const { assignmentState, setAssignmentState } = useAssignmentStoreDefaults();
  const { assignments, groupAssignments } = useGetAssignments({
    patientId: patient?.uuid || undefined,
  });
  const { submissions, groupSubmissions } = useGetSubmissions({});

  useEffect(() => {
    let assignmentsArr = [] as Array<Assignment>;
    let submissionsArr = [] as Array<AssignmentSubmission>;
    if (patient) {
      if (!assignments || !submissions) return;
      assignmentsArr = structuredClone(assignments);
      submissionsArr = structuredClone(submissions);
    } else if (group) {
      if (!groupAssignments || !groupSubmissions) return;
      assignmentsArr = structuredClone(groupAssignments);
      submissionsArr = structuredClone(groupSubmissions);
    }
    setAssignmentState({
      assignments: assignmentsArr,
      submissions: submissionsArr,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AssignmentStateContext.Provider value={assignmentState}>
      <AssignmentDispatchContext.Provider value={setAssignmentState}>
        {assignmentState.initialized && children}
      </AssignmentDispatchContext.Provider>
    </AssignmentStateContext.Provider>
  );
};

export default AssignmentContextTherapistWrapper;
